// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ed5ac3c","239":"2bef6e2f","453":"7007e88c","667":"3aa1d99d","843":"5a19b5f0"}[chunkId] + ".chunk.js";
};